import { AxiosResponse } from 'axios';
import { HTTP } from '@/utils';
import { GradesOptions, PersonGrades, PersonGradesRequest } from '@/types/GradeInterface';

export default class GradeService {
  static resource_grades = 'grades';
  static resource_person = 'person';
  static resource_organization = 'organization';

  private static extractData<T>(response: AxiosResponse<{ data: T }>): T {
    return response.data.data;
  }

  private static personGradesUrl(id: number) {
    return `${this.resource_person}/${id}/${this.resource_grades}`;
  }

  private static personGradesOrganizationUrl(person_id: number, organization_id: number) {
    return `${this.resource_person}/${person_id}/${this.resource_organization}/${organization_id}/${this.resource_grades}`;
  }

  static async getGradesOptions(): Promise<GradesOptions[]> {
    const response = await HTTP.get(`grades`);
    return this.extractData<GradesOptions[]>(response);
  }

  static async getPersonGrades(person_id: number): Promise<PersonGrades[]> {
    const response = await HTTP.get(this.personGradesUrl(person_id));
    return this.extractData<PersonGrades[]>(response);
  }

  static async attachPersonGrades(
    payload: PersonGradesRequest,
    person_id: number,
    organization_id: number,
  ): Promise<PersonGradesRequest> {
    const response = await HTTP.post(`${this.personGradesOrganizationUrl(person_id, organization_id)}/attach`, payload);
    return this.extractData<PersonGradesRequest>(response);
  }

  static async detachPersonGrades(
    payload: PersonGradesRequest,
    person_id: number,
    organization_id: number,
  ): Promise<PersonGradesRequest> {
    const response = await HTTP.post(`${this.personGradesOrganizationUrl(person_id, organization_id)}/detach`, payload);
    return this.extractData<PersonGradesRequest>(response);
  }
}
